import { Injectable } from '@angular/core';

@Injectable()
export class ResponsiveService {

    public mobileDevice: boolean;

    constructor() {
    }

    isMobile() {
        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
        ) {
            this.mobileDevice = true;
        }
        else {
            this.mobileDevice = false;
        }
    }

}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/services/responsive.service.ts